import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const MaterialHomeService = {
    getHomeInfo: async () => axios.get(`${API_URL}/materials/home/info`).then(({data}) => data).catch((err) => { throw err }),
}

export default MaterialHomeService;